export interface SessionRequestConfirmation {
  email: string;
  orderNumber: string;
}

const SESSION_REQUEST_CONFIRMATION_KEY = "sessionRequestConfirmation";

export const saveSessionRequestConfirmation = (confirmation: SessionRequestConfirmation): void => {
  try {
    sessionStorage.setItem(SESSION_REQUEST_CONFIRMATION_KEY, JSON.stringify(confirmation));
  } catch {
    // The Redux success state still keeps the confirmation page available when storage is blocked.
  }
};

export const getSessionRequestConfirmation = (): SessionRequestConfirmation | null => {
  try {
    const confirmation = sessionStorage.getItem(SESSION_REQUEST_CONFIRMATION_KEY);
    return confirmation ? (JSON.parse(confirmation) as SessionRequestConfirmation) : null;
  } catch {
    return null;
  }
};

export const hasSessionRequestConfirmation = (): boolean => Boolean(getSessionRequestConfirmation());

export const clearSessionRequestConfirmation = (): void => {
  try {
    sessionStorage.removeItem(SESSION_REQUEST_CONFIRMATION_KEY);
  } catch {
    // Nothing else is required when storage is unavailable.
  }
};
